import { Component, Input, OnChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import lodash from 'lodash';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
})
export class ReadMoreComponent implements OnChanges {
  @Input() content: string | any[];
  @Input() inline = false;
  @Input() maxLength = 100;
  @Input() delimiter = ', ';

  public fitContent = null;
  public contentSuffix = null;

  constructor(private modalService: NgbModal) { }

  ngOnChanges() {
    this.transformToFitLength();
  }

  filter(array: any[]) {
    return array.filter((element) => !!element);
  }

  getSafeFullText() {
    if (lodash.isArray(this.content)) {
      return this.content.join(this.delimiter);
    }

    return this.content;
  }

  transformToFitLength() {
    if (!this.content) {
      return;
    }

    this.fitContent = '';
    this.contentSuffix = '';

    if (lodash.isString(this.content)) {
      return this.transformTextToFitLength();
    }

    if (lodash.isArray(this.content)) {
      return this.transformArrayToFitLength();
    }
  }

  transformTextToFitLength() {
    const adjustedMaxLength = this.maxLength - 3;

    let fitContent = (this.content as string).trim();
    fitContent = fitContent.substr(0, adjustedMaxLength);

    this.contentSuffix = this.content.length > adjustedMaxLength ?
      '...' :
      null;

    this.fitContent = fitContent;
  }

  transformArrayToFitLength() {
    const adjustedMaxLength = this.maxLength - 8;

    let consumedCount = 0;
    let fitContent = '';

    for (const item of this.content) {
      const trial = this.filter([fitContent, item])
        .join(this.delimiter)
        .trim();

      if (trial.length > adjustedMaxLength) {
        break;
      }

      consumedCount += 1;
      fitContent = trial;
    }

    const remainingCount = this.content.length - consumedCount;

    this.contentSuffix = remainingCount > 0 ?
      ` + ${remainingCount} More` :
      '';

    this.fitContent = fitContent;
  }

  shouldShowNonInlineDecor() {
    return !!this.getSafeFullText() && this.contentSuffix;
  }

  openMoreInfoDialog() {
    const modal: any = this.modalService.open(InfoDialogComponent, {
      scrollable: true,
      centered: true,
    });

    modal.componentInstance.content = this.getSafeFullText();
  }
}
